/** A client's place on the path from invitation to trading: four steps and what comes next. */
import { STAGES, type ClientRow } from "./roster";

export function ClientProgress({ row }: { readonly row: ClientRow }): React.JSX.Element {
  const done = row.reached === STAGES.length;
  return (
    <div className="flex min-w-40 flex-col gap-1" data-testid="client-stage" data-reached={row.reached}>
      <div className="flex gap-1" aria-hidden="true">
        {STAGES.map((stage, index) => (
          <span
            key={stage}
            title={stage}
            className={`h-1.5 flex-1 rounded-full ${index < row.reached ? (done ? "bg-status-positive" : "bg-action-primary") : "bg-border-subtle"}`}
          />
        ))}
      </div>
      <span className="text-helper-sm text-text-secondary">{row.next}</span>
    </div>
  );
}
